import { render } from "./external-access.vue?vue&type=template&id=ea8c50a0&scoped=true"
import script from "./external-access.vue?vue&type=script&lang=js"
export * from "./external-access.vue?vue&type=script&lang=js"

import "./external-access.vue?vue&type=style&index=0&id=ea8c50a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea8c50a0"]])

export default __exports__